module.exports = __webpack_public_path__ + "static/university.small.horizontal.white-9cbac26e94878e7a3bbd135d13f9cb06.png";